// import { useState } from "react";
// import { FaAngleDown, FaAngleUp } from "react-icons/fa";
import ProfileCard from "../ProfileCard";
import ExpandOnHover from "./../shared/ExpandOnHover";
import FloatUp from "./../shared/FloatUp";
import FloatRight from "./../shared/FloatRight";
import FloatLeft from "./../shared/FloatLeft";
import { getTeams } from "../../context/Actions";
import Loader from "../shared/Loader";
import { useEffect, useContext } from "react";
import AppContext from "../../context/Context";

export default function Team() {
  const { isLoading, teams, dispatch } = useContext(AppContext);
  // const [opened, setOpened] = useState(
  //   Object.values(teams).sort().reverse()[0]
  // );

  // const style = {
  //   display: "flex",
  //   justifyContent: "center",
  //   alignItems: "center",
  //   flexDirection: "column",
  // };

  useEffect(() => {
    dispatch({ type: "SET_LOADING" });
    const getTeamsToHydrate = async () => {
      const fetchedTeams = await getTeams();
      dispatch({
        type: "GET_TEAMS",
        payload: fetchedTeams,
      });
    };
    getTeamsToHydrate();
  }, [dispatch]);

  // useEffect(() => {
  //   setOpened(Object.keys(teams).sort().reverse()[0]);
  // }, [teams]);

  return (
    <div className="section">
      <div className="container">
        <div className="is-flex is-justify-content-center is-align-items-center is-flex-wrap-wrap">
          {teams.length !== 0 &&
            Object.values(teams)[0]
              .filter(
                (member) =>
                  member.designation === "General Secretary" ||
                  member.designation === "Co-Secretary"
              )
              .reverse()
              .map((member) => {
                if (isLoading) return <Loader />;
                else
                  return (
                    <ExpandOnHover key={member._id}>
                      {member.designation === "General Secretary" ? (
                        <FloatRight>
                          <ProfileCard details={member} />
                        </FloatRight>
                      ) : (
                        <FloatLeft>
                          <ProfileCard details={member} />
                        </FloatLeft>
                      )}
                    </ExpandOnHover>
                  );
              })}
        </div>
        <div className="is-flex is-justify-content-center is-align-items-center is-flex-wrap-wrap">
          {teams.length !== 0 &&
            Object.values(teams)[0]
              .filter(
                (member) =>
                  !(
                    member.designation === "Co-Secretary" ||
                    member.designation === "General Secretary"
                  )
              )
              .map((member) => (
                <ExpandOnHover key={member._id}>
                  <FloatUp>
                    <ProfileCard details={member} />
                  </FloatUp>
                </ExpandOnHover>
              ))}
        </div>
      </div>
    </div>
  );
}
